import WebLayout from './IconButtonLayout.web';
import MobileLayout from './IconButtonLayout.mobile';
import { isReactNative } from 'ui-builder';

export default isReactNative() ? MobileLayout : WebLayout;
